import { createActionTypes } from 'lib/utils/createActionTypes';

export default class EventDucks {
	public static initialState = {
		events: [],
		isLoaded: false,
	};

	public static duckName = 'Event';

	public static actionTypes: any = createActionTypes(
		{
			getEvent: 'get_event'.toUpperCase(),
			getEvents: 'get_events'.toUpperCase(),
			setUserEvents: 'set_user_events'.toUpperCase(),
		},
		EventDucks.duckName,
	);

	public static setUserEvents = (events: any[]) => dispatch => {
		dispatch({
			type: EventDucks.actionTypes.setUserEvents,
			payload: { events },
		});
	};
	public static getOwnState = state =>
		state[EventDucks.duckName] || EventDucks.initialState;
	public static getEvents(state) {
		return this.getOwnState(state).events;
	}

	public static reducer(state = EventDucks.initialState, action) {
		switch (action.type) {
			case EventDucks.actionTypes.setUserEvents:
				return {
					...state,
					isLoaded: true,
					events: action.payload.events,
				};

			default:
				return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/ducks/Event.duck.ts